import PaymentsCard from 'components/PaymentsCard';
import { ContentHeading } from 'components/Typography';
import ChargesLineItem from 'components/ChargesLineItem';

interface Penalty {
  amount: string;
  currency: string;
}

interface PropertyChargesProps {
  penalty: Penalty[];
}

const PropertyCharges = ({ penalty }: PropertyChargesProps) => {
  if (!penalty.length) {
    return null;
  }

  return (
    <>
      <ContentHeading>Charges & penalties</ContentHeading>
      <PaymentsCard mb={8}>
        <ChargesLineItem penalty={penalty} />
      </PaymentsCard>
    </>
  );
};

export default PropertyCharges;
